

import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa6";
import { CiMail } from "react-icons/ci";
import { useTranslation } from "react-i18next";
import axios from 'axios';
import { contact, contact1, contact2, contact3, contact4, contact5, contactBg, contactWhite1, contactWhite2, contactWhite3, contactWhite4, contactWhite5, gRight, whatsapp } from "../../assets/index";
import { useNavigate } from "react-router-dom";

const Contact = () => {

    const { t, i18n } = useTranslation();
           const currentLanguage = i18n.language; // Aktif dili alıyoruz

   const navigate = useNavigate();

   const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });
    const [responseMessage, setResponseMessage] = useState({ text: '', isError: false });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (event) => {
      event.preventDefault();
    
      // Form validation
      if (!formData.name || !formData.email || !formData.phone || !formData.message) {
        setResponseMessage({ text: 'Lütfen tüm alanları doldurunuz.', isError: true });
        return;
      }
    
      try {
        // Backend'inizin beklediği form-data formatında gönderim
        const formDataToSend = new FormData();
        formDataToSend.append('name', formData.name);
        formDataToSend.append('email', formData.email);
        formDataToSend.append('phone', formData.phone);
        formDataToSend.append('message', formData.message);
    
        const response = await axios.post(
          'https://www.gpr.az/gpr/contact.php',
          formDataToSend, 
          { 
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );
    
        // Backend yanıtını işleme
        const responseData = response.data;
        if (responseData.status === 1) {
          setResponseMessage({ text: responseData.message || 'Veri başarıyla gönderildi!', isError: false });
          navigate(`/${currentLanguage}`);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100); // 100ms gecikme yeterlidir
           
          // Formu temizle
          setFormData({
            name: '',
            email: '',
            phone: '',
            message: ''
          });
        } else {
          setResponseMessage({ 
            text: responseData.message || 'İşlem başarısız oldu', 
            isError: true 
          });
        }
      } catch (error) {
        console.error('API Hatası:', error);
        let errorMessage = 'Sunucuya bağlanırken bir hata oluştu';
        
        // Sunucudan gelen hatayı işleme
        if (error.response) {
          errorMessage = error.response.data?.message || 
                         (error.response.data ? JSON.stringify(error.response.data) : error.message);
        }
        
        setResponseMessage({ 
          text: errorMessage, 
          isError: true 
        });
      }
    };

  return (
    <> 
   <div className="pt-[79px]">
   <div className="max-w-containerSm md:max-w-container md:mt-[52px] mt-[20px] mx-auto">
     <div className='md:mb-[40px] mb-[20px] text-center'>
       <div className="flex justify-center items-center mx-auto">
  {/* Dekoratif Duvar */}
  <div className="w-[2px] h-[20px] bg-[#E0B497] mb-4 mt-4"></div>
  {/* Metin */}
  <p className="text-[16px] font-medium text-center text-[#E0B497] ml-[5px]">
  {t("Əlaqə")}
  </p>
  
</div>

      <p className='text-[28px] md:text-[40px]  font-bold text-center '>
          <span className="text2-gradient">{t("Bizimlə əlaqə saxlayın")}</span> 
          </p>
     </div>
   </div>
   <div className="grid grid-cols-2 md:grid-cols-5 max-w-containerSm md:max-w-container mx-auto gap-5">
  <a target='_blank' href='tel:+994102144814'>
  <div className="rounded-[16px] border-[#4E4E4E] border-[1px] bg-[#020202] px-[24px] py-[48px] box-border group transition-all duration-300 ease-in-out hover:bg-primeColor">
    <img className="h-10 w-10 group-hover:hidden" src={contact1}></img>
    <img className="h-10 w-10 hidden group-hover:block" src={contactWhite1}></img>
  <p className="text-[#C4C4C4] font-semibold mt-6 group-hover:text-[white]">{t("Əlaqə nömrəsi")}</p>
  <p className="text-[white] font-semibold text-[18px]">+994 10 214 48 14</p>
  </div>
  </a>
  <a target='_blank' href='mailto:info@gpr.az'>
  <div className="rounded-[16px] border-[#4E4E4E] border-[1px] bg-[#020202] px-[24px] py-[48px] box-border group transition-all duration-300 ease-in-out hover:bg-primeColor">
  <img className="h-10 w-10 group-hover:hidden" src={contact2}></img>
  <img className="h-10 w-10 hidden group-hover:block" src={contactWhite2}></img>
  <p className="text-[#C4C4C4] font-semibold mt-6 group-hover:text-[white]">{t("E-mail")}</p>
  <p className="text-[white] font-semibold text-[18px]">info@gpr.az</p>
  </div>
  </a>
<a target='_blank' href='https://www.instagram.com/gpr.company/'>
<div className="rounded-[16px] border-[#4E4E4E] border-[1px] bg-[#020202] px-[24px] py-[48px] box-border group transition-all duration-300 ease-in-out hover:bg-primeColor">
  <img className="h-10 w-10 group-hover:hidden" src={contact3}></img>
  <img className="h-10 w-10 hidden group-hover:block" src={contactWhite3}></img>
  <p className="text-[#C4C4C4] font-semibold mt-6 group-hover:text-[white]">{t("İnstagram")}</p>
  <p className="text-[white] font-semibold text-[18px]">@gpr.az</p>
  </div>
</a>
<a target='_blank' href='https://www.facebook.com/profile.php?id=61565031273402'>
<div className="rounded-[16px] border-[#4E4E4E] border-[1px] bg-[#020202] px-[24px] py-[48px] box-border group transition-all duration-300 ease-in-out hover:bg-primeColor">
  <img className="h-10 w-10 group-hover:hidden" src={contact4}></img>
  <img className="h-10 w-10 hidden group-hover:block" src={contactWhite4}></img>
  <p className="text-[#C4C4C4] font-semibold mt-6 group-hover:text-[white]">{t("Facebook")}</p>
  <p className="text-[white] font-semibold text-[18px]">@gpr.az</p>
  </div>
</a>
  <a target='_blank' href='https://www.linkedin.com/in/gpr-marketing-37a7a7325/'>
  <div className="rounded-[16px] border-[#4E4E4E] border-[1px] bg-[#020202] px-[24px] py-[48px] box-border group transition-all duration-300 ease-in-out hover:bg-primeColor">
  <img className="h-10 w-10 group-hover:hidden" src={contact5}></img>
  <img className="h-10 w-10 hidden group-hover:block" src={contactWhite5}></img>
  <p className="text-[#C4C4C4] font-semibold mt-6 group-hover:text-[white]">{t("LinkedIn")}</p>
  <p className="text-[white] font-semibold text-[18px]">@gpr.az</p>
  </div>
  </a>
   </div>
      <div>
    <div className='mx-auto mt-10 md:mt-[100px] mb-[40px] md:mb-[160px] max-w-containerSm md:max-w-[1260px]'>
 <div className='md:flex mb-[40px] justify-between'>
<div className='md:w-[55%]'>
<form onSubmit={handleSubmit} class="space-y-8">
      <div>
        <label for="name" class="block text-base font-medium text-[white]">{t("Ad, soyad")}</label>
        <input name="name"
               value={formData.name}
               onChange={handleChange}
               required
               type="text" id="name" class="bg-[#292828] text-white mt-2 block w-full pl-3 pr-3 h-10  rounded-xl shadow-sm focus:outline-none sm:text-sm " ></input>
      </div>

    
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6"> 
    <div>
        <label for="phone"  class="block text-base font-medium text-[white]">{t("Əlaqə nömrəsi")}</label>
        <input  name="phone"
               value={formData.phone}
               onChange={handleChange}
               required
               type="phone" id="phone" class="bg-[#292828] text-white mt-2 block w-full pl-3 pr-3 h-10 rounded-xl shadow-sm focus:outline-none sm:text-sm " ></input>
      </div>
    <div>
        <label for="email" class="block text-base font-medium text-[white]">{t("E-mail")}</label>
        <input name="email"
               value={formData.email}
               onChange={handleChange}
               required
               type="text" id="email" class="bg-[#292828] text-white mt-2 block w-full pl-3 pr-3 h-10  rounded-xl shadow-sm focus:outline-none sm:text-sm " ></input>
      </div>
    </div>

    <div>
      <label for="message" class="block text-base font-medium text-[white]">{t("Mesajınız")}</label>
      <textarea name="message" value={formData.message}
               onChange={handleChange}
               required 
               placeholder={t("Bizə yazın...")} id="message" rows="4" class="bg-[#292828] text-white h-36 mt-2 pl-3 pr-3 pt-3 block w-full rounded-xl shadow-sm focus:outline-none sm:text-sm" ></textarea>
    </div>

    <div class="flex justify-start">
      <button type="submit" class="w-[148px] h-10 p-2.5 bg-primeColor rounded-xl justify-center items-center gap-2.5 inline-flex text-[white]">{t("GÖNDƏR")}</button>
    </div>
  </form>
 </div>
 <div className='md:w-[37%] flex flex-col justify-between mt-4 md:mt-0'>
 <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d194473.18588939894!2d49.8549596!3d40.394592499999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40307d6bd6211cf9%3A0x343f6b5e7ae56c6b!2zQmFrxLE!5e0!3m2!1saz!2saz!4v1733142028974!5m2!1saz!2saz" width="100%" height="445" style={{borderRadius:"8px"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
</div> 
 </div>
    </div>
  </div>
   </div>
    </>

  );
};

export default Contact;